import InternalUpload from './upload';
import Dragger from './dragger';
export * from './upload';
var Upload = InternalUpload;
Upload.Dragger = Dragger;
export default Upload;